import ExportLink from 'components/common/ExportLink';
import { MenuDetail, SubTitleMenuExportCSV } from 'features/SubTitleMenu/models/SubTitleMenu';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface subTitleMenusProp {
  subTitleMenus: MenuDetail[];
}
export default function ExportCSV({ subTitleMenus }: subTitleMenusProp) {
  const { t } = useTranslation();
  const [data, setData] = useState<SubTitleMenuExportCSV[]>([]);

  useEffect(() => {
    let dataCSV: SubTitleMenuExportCSV[] = [];
    for (const subTitleMenu of subTitleMenus) {
      dataCSV.push({
        menu_code: subTitleMenu.menu ? subTitleMenu.menu.food_system_menu?.cd : '',
        menu_name: subTitleMenu.menu?.food_system_menu?.name,
        menu_type: 'サブ',
        start_date: subTitleMenu.start_date.toString(),
        end_date: subTitleMenu.end_date.toString(),
        display_name: subTitleMenu.menu.display_name,
        display_name_ja: subTitleMenu.menu.display_name_ja,
        display_name_en: subTitleMenu.menu.display_name_en,
        display_name_vi: subTitleMenu.menu.display_name_vi,
        display_name_ko: subTitleMenu.menu.display_name_ko,
        display_name_zh_hant: subTitleMenu.menu.display_name_zh_hans,
        display_name_zh_hans: subTitleMenu.menu.display_name_zh_hant,
        explanation: subTitleMenu.menu.explanation,
        explanation_ja: subTitleMenu.menu.explanation_ja,
        explanation_en: subTitleMenu.menu.explanation_en,
        explanation_vi: subTitleMenu.menu.explanation_vi,
        explanation_ko: subTitleMenu.menu.explanation_ko,
        explanation_zh_hant: subTitleMenu.menu.explanation_zh_hant,
        explanation_zh_hans: subTitleMenu.menu.display_name_zh_hans,
        note: subTitleMenu.menu.note,
      });
    }
    setData(dataCSV);
  }, [subTitleMenus]);

  const headers = [
    { header: 'メニューコード', key: 'menu_code' },
    { header: 'メニューコード', key: 'menu_name' },
    { header: 'メニュー種別', key: 'menu_type' },
    { header: '開始', key: 'start_date' },
    { header: '終了', key: 'end_date' },
    { header: 'メニュー名', key: 'display_name' },
    { header: '表示名日本語', key: 'display_name_ja' },
    { header: '表示名英語', key: 'display_name_en' },
    { header: '表示名ベトナム語', key: 'display_name_vi' },
    { header: '表示名韓国語', key: 'display_name_ko' },
    { header: '表示名中国語(繁体字)', key: 'display_name_zh_hant' },
    { header: '表示名中国語（簡体字)', key: 'display_name_zh_hant' },
    { header: '説明', key: 'explanation' },
    { header: '説明日本語', key: 'explanation_ja' },
    { header: '説明英語', key: 'explanation_en' },
    { header: '説明ベトナム語', key: 'explanation_vi' },
    { header: '説明韓国語', key: 'explanation_ko' },
    { header: '説明中国語(繁体字)', key: 'explanation_zh_hant' },
    { header: '説明中国語（簡体字)', key: 'explanation_zh_hans' },
    { header: '備考', key: 'note' },
  ];

  return (
    <>
      <ExportLink target="_blank" filename={'sub_title_menu.csv'} data={data} headers={headers}>
        {<div dangerouslySetInnerHTML={{ __html: t('SubTitleMenu.Button.export_csv') }}></div>}
      </ExportLink>
    </>
  );
}
